import { createUser, getUsers, searchUser,requestAddUser,getUsersContact,requestAproveUser,requestRemoveUser } from '../../Models/Management/UserProf_Model';

import { Fetch } from "../../Models/shared/general"
export const onGetUser = async function (data) {
    const reqdata = await getUsers({});
    let failedData = {
        status: "err",
        data: {},
        statusCode: reqdata === undefined ? 455 : 500,
        msg: "Encountered an internal problem. Try again"
    }

    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result;
}

export const onGetUserContact = async function (data) {
    const reqdata = await getUsersContact(data);
    let failedData = {
        status: "err",
        data: {},
        statusCode: reqdata === undefined ? 455 : 500,
        msg: "Encountered an internal problem. Try again"
    }

    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result;
}


export const onSearchUser = async function (data) {
    const reqdata = await searchUser(data);
    let failedData = {
        status: "err",
        data: {},
        statusCode: reqdata === undefined ? 455 : 500,
        msg: "Encountered an internal problem. Try again"
    }

    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result;
}

export const onRequestAddUser = async function (data) {
    const reqdata = await requestAddUser(data);
    let failedData = {
        status: "err",
        data: {},
        statusCode: reqdata === undefined ? 455 : 500,
        msg: "Encountered an internal problem. Try again"
    }

    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result;
}

export const onRequestAproveUser = async function (data) {
    const reqdata = await requestAproveUser(data);
    let failedData = {
        status: "err",
        data: {},
        statusCode: reqdata === undefined ? 455 : 500,
        msg: "Encountered an internal problem. Try again"
    }

    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result;
}

export const onRequestRemoveUser = async function (data) {
    const reqdata = await requestRemoveUser(data);
    let failedData = {
        status: "err",
        data: {},
        statusCode: reqdata === undefined ? 455 : 500,
        msg: "Encountered an internal problem. Try again"
    }

    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result;
}
//alice 
export const onCreateUser = async function (data) {
    const reqdata = await createUser(data);
    let failedData = {
        status: "err",
        data: {},
        statusCode: reqdata === undefined ? 455 : 500,
        msg: "Encountered an internal problem. Try again"
    }
    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result
}

//jjason
export const getUserbyType = async function (userType) {
    let failedData = {
        status: "err",
        data: {},
        statusCode: 500,
        msg: "Encountered an internal problem. Try again"
    }
    if (!userType) {
        failedData.message = "inComplete parameter"
        return failedData;
    }
    const reqdata = await Fetch({ action: "user_type_profile", data: { type: userType } })
    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result
}

export const UserUpdatebyId = async function (data) {
    let failedData = {
        status: "err",
        data: {},
        statusCode: 500,
        msg: "Encountered an internal problem. Try again"
    }
    if (!data.userid) {
        failedData.message = "inComplete parameter"
        return failedData;
    }
    const reqdata = await Fetch({ action: "update_user", data: data })
    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result
}
export const UserGetbyType = async function (data) {
    let failedData = {
        status: "err",
        data: {},
        statusCode: 500,
        msg: "Encountered an internal problem. Try again"
    }
    if (!data.userid) {
        failedData.message = "inComplete parameter"
        return failedData;
    }
    const reqdata = await Fetch({ action: "user_get_by_type", data: data })
    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result

}

export const getAllUserLists = async function (data) {
    let failedData = {
        status: "err",
        data: {},
        statusCode: 500,
        msg: "Encountered an internal problem. Try again"
    }
    const reqdata = await Fetch({ action: "list_all_user", data: data })
    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result
}
export const validateUser = async function (data) {
    let failedData = {
        status: "err",
        data: {},
        statusCode: 500,
        msg: "Encountered an internal problem. Try again"
    }
    const reqdata = await Fetch({ action: "validate_user", data: data })
    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result
}

export const updateUserPassword = async function (data) {
    let failedData = {
        status: "err",
        data: {},
        statusCode: 500,
        msg: "Encountered an internal problem. Try again"
    }
    const reqdata = await Fetch({ action: "update_user_password", data: data })
    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result
}

// 20210826 Get User By Parsing ID
export const getUserbyId    = async function(data){
    let failedData = {
        status: "err",
        data: {},
        statusCode: 500,
        msg: "Encountered an internal problem. Try again"
    }
    if (!data.userid) {
        failedData.message = "inComplete parameter"
        return failedData;
    }
    const reqdata = await Fetch({ action: "get_user_byid", data: data })
    const result = reqdata && reqdata !== undefined && reqdata.status ? await reqdata.json() : failedData
    return result

}